import { Component, OnInit, Injectable } from '@angular/core';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { UserRequest } from 'src/app/model';
import { UserService } from 'src/app/service';
interface FcmReportNode {
  name: string;
  children?: FcmReportNode[];
  url:string;
}

interface FcmFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  url:string;
}
const  TREE_DATA: FcmReportNode[] = [
  
//   {
//     name: 'Ytd Dashboard',url:'ytd',
//     children: [
//       {name: 'Service',url:'allservice',
//          children: [
//             {name: 'Transaction Analysis',url:''},
//             {name: 'Volume in INR%',url:''},
//             {name: 'DIC Code',url:''},
//               ]
//     },
//       {name: 'Airlines',url:'airlines',
//           children: [
//             {name: 'Top Domestic',url:'topdom'},
//             {name: 'Top International',url:'topin'},
//             {name: 'Cancellation',url:'can'},
//         ]
//       },
//     ]
//   }, 
//     {name: 'Product Wise Spend',url:'pws',
//         children: [
//          {name: 'Mtd',url:'pwsmtd'},
//          {name: 'Ytd',url:'pwsytd'},
//          {name: 'All',url:'pwsall'},
// ]
// },
//      {name: 'Average Ticket Price',url:'atp',
//          children: [
//            {name: 'Average Ticket By Class Type',url:'',
//               children: [
//                 {name: 'Mtd',url:'',
//                       children: [
//                          {name: 'Domestic',url:''},
//                          {name: 'International',url:''},
//                          {name: 'Over All',url:''},
//          ]
//                 },
//                 {name: 'Ytd',url:'',
//                        children: [
//                           {name: 'Domestic',url:''},
//                           {name: 'International',url:''},
//                           {name: 'Over All',url:''},
//                      ]
//                 },
                
//    ]

//            },
//            {name: 'Average Ticket Price By Class',url:'atpbyclass',
//                children: [
//                   {name: 'Mtd',url:'atpmtd',
//                           children: [
//                               {name: 'Domestic',url:'atpd'},
//                               {name: 'International',url:'atpi'},
//                               {name: 'Over All',url:'atpo'},
//                             ]
//                   },
//                   {name: 'Ytd',url:'atpytd',
//                             children: [
//                                         {name: 'Domestic',url:'atpd'},
//                                         {name: 'International',url:'atpi'},
//                                         {name: 'Over All',url:'atpo'},
//                                       ]
//                                   },
                  
//                           ]         
//             },
          
// ]
// },
//   {
//     name: 'Fcs Vs Lcc',url:'',
//     children: [
//       {name: 'Mtd',url:'',
//       children: [
//         {name: 'Transaction',url:''},
//         {name: 'Spend',url:''},
//    ]
//       },
//       {name: 'Ytd',url:'',
//          children: [
//            {name: 'Transaction',url:''},
//            {name: 'Spend',url:''},
//    ]
//       },
     
//     ]
//   },

//   {name: 'Refund',url:'',
//   children: [
//    {name: 'Mtd',url:''},
//    {name: 'Ytd',url:''},
//    {name: 'Mtd Cancellation',url:''},
//    {name: 'Ytd Cancellation',url:''},
// ]
// }, 

// {name: 'Advance Purchase Ytd',url:'',
// children: [
//  {name: 'International Business',url:''},
//  {name: 'International Economy',url:''},
//  {name: 'Domestic Business',url:''},
//  {name: 'International Over all',url:''},
//  {name: 'Domestic Over all',url:''},
// ]
// },





{name: 'Escalation',url:'report-incident-dashboard',
children: [
  {name: 'Escalation Form',url:'report-incident'},
]
},


{name: 'Appreciation',url:'log-appreciation-dashboard',
children: [
  {name: 'Appreciation Form',url:'log-appreciation'},
]
},



{name: 'Waivers And Favors',url:'waivers-favors-report',
children: [
 {name: 'Waivers And Favors Form',url:'waivers-favors'},
]
},

{name: 'Common Dashboard',url:'common-dashboard',
// children: [
// {name: 'ABC',url:'abc'},
// ]
},

{name: 'Sales Report',url:'sale-report',
// children: [
// {name: 'ABC',url:'abc'},
// ]
},


{name: 'Missed Saving Report',url:'missed-saving-report',
// children: [
//  {name: 'ABC',url:''},
// ]
},

{name: 'Corporate Vs Retail Fare Sale',url:'corp-vs-retail-fare-sale',
// children: [
//  {name: 'ABC',url:''},
// ]
},

{name: 'Lead Time',url:'lead-time',
// children: [
//  {name: 'ABC',url:''},
// ]
},

{name: 'Product Wise Spend',url:'product-wise-spend',
// children: [
//  {name: 'ABC',url:''},
// ]
},

{name: 'Cancellation/Re-Issuance',url:'cancellation-re-issuance',
// children: [
//  {name: 'ABC',url:''},
// ]
},

{name: 'Destination Wise Report',url:'destination-wise-report',
// children: [
//   {name: 'ABC',url:'hotel'},
// ]
},

{name: 'Carrier Wise Report',url:'carrier-wise-report',
// children: [
//  {name: 'ABC',url:'',},
// ]
},

{name: 'Hotel Wise Report',url:'hotel-wise-report',
// children: [
//   {name: 'ABC',url:''},
//  ]
},

{name: 'Create Corporate',url:'create-corporate',
// children: [
//   {name: 'ABC',url:''},
//  ]
},


// {name: 'Issues And Appreciation',url:'issues-and-appreciation',
// children: [
//  {name: 'ABC',url:''},
// ]
// },

// {name: 'Regional KAM Level Reports',url:'regional-kam-level-report',
// children: [
//  {name: 'ABC',url:''},
// ]
// },

// {name: 'Global vs. Local Clients',url:'global-vs-local-client',
// children: [
//  {name: 'ABC',url:''},
// ]
// },

// {name: 'SLA Tracking For Specific Clients Via Excel Sheet Upload',url:'sla-tracking-for-specific-clients-via-excel-sheet-upload',
// children: [
//  {name: 'ABC',url:''},
// ]
// },


];


const  _DATA: FcmReportNode[] = [  
  {name: 'Escalation',url:'report-incident-dashboard',
  // children: [
  //   {name: 'Escalation Form',url:'report-incident'},
  // ]
  },
  
  
  {name: 'Appreciation',url:'log-appreciation-dashboard',
  // children: [
  //   {name: 'Appreciation Form',url:'log-appreciation'},
  // ]
  },
  
  
  
  {name: 'Waivers And Favors',url:'waivers-favors-report',
  // children: [
  //  {name: 'Waivers And Favors Form',url:'waivers-favors'},
  // ]
  },
  
  ];

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.css']
})
export class DrawerComponent implements OnInit {
  userRequest:UserRequest;
  private _transformer = (node: FcmReportNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      url:node.url,
      level: level,
    };
  }
 
  treeControl = new FlatTreeControl<FcmFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(private userService: UserService) {
  }

  hasChild = (_: number, node: FcmFlatNode) => node.expandable;

  ngOnInit() {
    this.refreshCurrentUser();
  }


  public refreshCurrentUser() {
    this.userService.findUser(localStorage.getItem("email")).subscribe(data => {
        this.userRequest = data;
      // localStorage.setItem("roleName", this.userRequest.role.roleName);
      // localStorage.setItem("userId", this.userRequest.id.toString());
      // localStorage.setItem("roleId", this.userRequest.role.id.toString())
      if(this.userRequest.role.roleName=='Point of sale'||this.userRequest.role.roleName=='KAM' ||this.userRequest.role.roleName=='TL Reports'){
        this.dataSource.data = _DATA;
      }else{
        this.dataSource.data = TREE_DATA;
      }
    });
  }
}
